module.exports = __webpack_public_path__ + "img/8.35248cc9.png";